import InfoLayer from '../../Components/InfoLayer'
// TODO: InfoLayer clickthrough via css pointerevents none
class InfoLayerContainer {
    element = document.querySelector('#info-layer-container') as HTMLDivElement

    constructor() {
        window.addEventListener('keydown', (e) => {
            if (e.key === ' ') {
                this.show()
            }
        })

        window.addEventListener('keyup', (e) => {
            if (e.key === ' ') {
                this.hide()
            }
        })
    }

    show = () => {
        this.element.classList.remove('hidden')
    }

    hide = () => {
        this.element.classList.add('hidden')
    }

    setInfoLayer = (infoLayer: InfoLayer) => {
        if (this.element.hasChildNodes()) {
            this.element.replaceChild(infoLayer.element, this.element.firstChild as ChildNode)
        } else {
            this.element.appendChild(infoLayer.element)
        }
    }

    unsetInfoLayer = () => {
        this.element.removeChild(this.element.firstChild as ChildNode)
    }
}

export default new InfoLayerContainer()
